export default class Ws {
    constructor(store, url, cb) {
        this.store = store;
        this.ws = new WebSocket(url);
        this.wsConnectState = 0;
        this.timeout = 180000;
        this.timeoutObj = null;
        this.serverTimeoutObj = null;
        this.url = url;
        this.cb = cb;
        this.canClose = false;
    }
    wsAddEvent() {
        this.ws.onopen = () => {
            this.reset();
            this.start();
            this.ws.send(`heartbeat=${1212121212}`);
            this.wsConnectState = 1;
        }
        this.ws.onclose = (evt) => {
            if (this.canClose == false) {
                this.reconnect();
            }
        }
        this.ws.onError = (evt) => {
            this.reconnect();
        }
        this.ws.onmessage = (evt) => {
            this.reset();
            this.start();
            let data = evt.data;
            this.cb && this.cb(data, this.ws);
        };

    }
    close() {
        this.canClose = true;
        this.ws.close();
    }
    reset() {
        clearTimeout(this.timeoutObj);
        clearTimeout(this.serverTimeoutObj);
    }
    start() {
        this.timeoutObj = setTimeout(() => {
            let dataTime = new Date();
            let dataTimeFlag = dataTime.format('YYYYMMDDhhmm')
            this.ws.send(`heartbeat=${dataTimeFlag}`);
            this.serverTimeoutObj = setTimeout(() => {
                this.ws.close();
            }, this.timeout)
        }, this.timeout)
    }
    reconnect() {
        this.ws = new WebSocket(this.url);
        this.wsAddEvent();
    }
}